exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-18cbed88] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.list .list-row[data-v-18cbed88] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 12px 0;\n}\n.list .list-row .key[data-v-18cbed88] {\n  font-weight: 400;\n  color: #484848;\n}\n.list .list-row .value[data-v-18cbed88] {\n  font-weight: 400;\n  color: #085FCE;\n}\n.list .divider[data-v-18cbed88] {\n  margin: 0;\n  border: 1px solid #EEF2F6;\n}\n.list .divider[data-v-18cbed88]:last-of-type {\n  display: none;\n}", ""]);

// exports
